export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-partner-info-retail',
  employersCountLabel: 'partnerbasicinfo-employers-count-retail',
  salesCountLabel: 'partnerbasicinfo-sales-count-retail',
}
